import React from "react";
import { Button, NumberInput, minValue, required, useNotify } from "react-admin";
import { Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";

const RequirementAchievementDialog = ({ studentEducationId, requirement, fetchRequirements }) => {
  const notify = useNotify();

  const handleSubmit = async ({ achievedCount }) => {
    // Send only this requirement so the backend records history for it alone
    await dataProvider.customRequest(
      graduationRequests.studentDisciplinesRequirements(studentEducationId),
      { requirements: [{ requirementId: requirement.requirementId, achievedCount }] },
      "PATCH",
    );
    notify("Успешно отбелязване на изпълнение", { type: "success" });
    fetchRequirements();
  };

  return (
    <FormModal
      titleContent="Отбелязване на изпълнение"
      onConfirm={handleSubmit}
      defaultValues={{ achievedCount: requirement?.achievedCount ?? 0 }}
      triggerButton={
        <Button
          label="Отбележи"
          variant="contained"
          startIcon={<EditIcon />}
        />
      }
    >
      <Typography sx={{ mb: 2 }}>
        {requirement?.disciplineNameBg} – <strong>{requirement?.requirementNameBg}</strong> (изискване:{" "}
        {requirement?.requiredCount})
      </Typography>
      <NumberInput
        source="achievedCount"
        label="Изпълнено"
        validate={[required(), minValue(0)]}
        fullWidth
      />
    </FormModal>
  );
};

export default RequirementAchievementDialog;
